// extracted by mini-css-extract-plugin
module.exports = {"root":"PageLayout_root__UFAg6","pageTitle":"PageLayout_pageTitle__INAln"};